import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router';
import { IonContent, IonPage, IonList, IonButton, IonIcon, IonImg, useIonViewWillEnter, useIonViewDidLeave, IonRefresher, IonRefresherContent } from '@ionic/react';
import { search } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { useHistory } from 'react-router-dom';
import { Constants } from '../defines/Constants';
import { Pagination } from 'react-rainbow-components';
import { ShowSwal } from '../defines/Functions';
import moment from 'jalali-moment';
import axios from "axios";
import HotelSort from '../components/search/modals/HotelSort';
import HotelFilter from '../components/search/modals/HotelFilter';
import HotelCard from '../components/search/HotelCard';
import Splash from '../components/Splash';
import hotelImagePlaceholder from '../assets/images/hotelImage.jpg';
import './HotelSearch.css';
import clockImg from '../assets/images/clock.svg';
import warningSign from '../assets/images/warning.svg';
import nextImg from '../assets/images/filter-next.svg';
import prevImg from '../assets/images/filter-prev.svg';

const HotelSearch = () => {
    const originalData = useRef({});
    const history = useHistory();
    const expireTime = useRef(900000);
    const expireInterval = useRef<any>(null);
    const currentPage = useLocation();
    const swalOptions = {
        html: '<div class="swal-html"><small><b>پایان زمان جستجو!</b></small><h6 class="title">مدت زمان اعتبار نتایج جستجو به اتمام رسید</h6><p>به منظور بروزرسانی قیمت ها لطفا جستجوی خود را از ابتدا انجام دهید.</p></div>',
        iconHtml: '<img src="' + clockImg + '" width="100" />',
        customClass: {
            container: ''
        },
        backdrop: true,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: 'جستجوی مجدد',
        confirmButtonColor: '#333D79',
        showDenyButton: false,
        denyButtonText: '',
        denyButtonColor: '',
        isConfirmed: () => history.replace('/home'),
        isDenied: () => { }
    }
    if (currentPage.pathname !== '/search/hotel') {
        clearInterval(expireInterval.current);
    }
    useIonViewDidLeave(() => {
        clearInterval(expireInterval.current);
    })
    let perPage = 10;
    const myRef = useRef<HTMLDivElement>(null);
    if (myRef.current) {
        var myRefCurrent = myRef.current;
    }
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState({});
    const [state, setState] = useState({
        totalPages: 1,
        activePage: 1,
        hotelData: [],
        errorMessage: '',
        hotelDefines: {
            cabinClass: '',
            targetName: '',
            all: {} as any
        },
        sortBy: 'priceAsc',
        filters: {
            hotelPrice: {
                lower: 0 as number,
                upper: 0 as number
            },
            hotelRate: [] as any,
            searchKeyword: '' as string,
            hotelCode: '' as any,
        },
        toggleCalendar: false
    });
    const [roomStays, setRoomStays] = useState({});
    const showRemoveFilter = useRef(false);
    const getHotelJson = async () => {
        const { value } = await Storage.get({ key: 'hotelJson' });
        if (value !== null) {
            return JSON.parse(value);
        }
    };
    const handleData = function (data: any) {
        setSearchData(data);
        if (data.hotelStays) {
            state.hotelDefines.targetName = data.targetName;
            let hotelStay = data.hotelStays.hotelStay;
            let hotelStayItems = [] as any;
            if (state.filters.searchKeyword) {
                showRemoveFilter.current = true;
                hotelStay = hotelStay.filter((item: any) => {
                    let itemSearchEl = item.hotelName;
                    let indexEl = itemSearchEl.search(state.filters.searchKeyword);
                    return (indexEl !== -1);
                })
            }
            if (state.filters.hotelCode) {
                showRemoveFilter.current = true;
                hotelStay = hotelStay.filter((item: any) => {
                    let itemSearchEl = item.basicPropertyInfo.hotelCode;
                    let indexEl = itemSearchEl.search(state.filters.hotelCode);
                    return (indexEl !== -1);
                })
            }
            if (state.filters.hotelPrice.lower && state.filters.hotelPrice.upper) {
                showRemoveFilter.current = true;
                hotelStay = hotelStay.filter((item: any) => {
                    let itemSearchEl = item.finalPrice;
                    return (itemSearchEl >= state.filters.hotelPrice.lower && itemSearchEl <= state.filters.hotelPrice.upper);
                })
            }
            if (Object.keys(state.filters.hotelRate).length !== 0) {
                showRemoveFilter.current = true;
                hotelStay = hotelStay.filter((item: any) => {
                    let itemSearchEl = parseInt(item.basicPropertyInfo.award[0].rating);
                    let foundItem = state.filters.hotelRate.filter((element: any) => {
                        return itemSearchEl === element.value;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            let totalPages = Math.ceil(hotelStay.length / perPage);
            []
                .concat(hotelStay)
                .sort((a: any, b: any) =>
                    state.sortBy === 'priceAsc' ?
                        (a.price[0].amountAfterTax > b.price[0].amountAfterTax ? 1 : -1)
                        : state.sortBy === 'priceDesc' ?
                            (a.price[0].amountAfterTax < b.price[0].amountAfterTax ? 1 : -1)
                            : state.sortBy === 'rateAsc' ?
                                (a.basicPropertyInfo.award[0].rating > b.basicPropertyInfo.award[0].rating ? 1 : -1)
                                :
                                (a.basicPropertyInfo.award[0].rating < b.basicPropertyInfo.award[0].rating ? 1 : -1)
                )
                .forEach((hotelStayItem: any) => {
                    hotelStayItems.push(hotelStayItem);
                })
            setState({ ...state, hotelData: hotelStayItems, totalPages: totalPages, activePage: 1, errorMessage: totalPages === 0 ? 'نتیجه ای یافت نشد!' : '' });
            setLoading(false);
        } else {
            setState({ ...state, hotelData: [], errorMessage: 'نتیجه ای یافت نشد!' });
        }
    }
    const fetchHotelSearch = async (action = 'normal') => {
        const valueJson = await getHotelJson();
        state.hotelDefines.all = valueJson;
        const hotelsSearch = Constants.api.hotelsSearch;
        let roomStayCandidates = '';
        valueJson[0].rooms.forEach((item: any) => {
            roomStayCandidates += '<RoomStayCandidate><GuestCounts>';
            roomStayCandidates += '<GuestCount AgeQualifyingCode="Adult" Count="' + item.adults + '" />';
            if (item.childsAges.length) {
                item.childsAges.forEach((childItem: any) => {
                    roomStayCandidates += '<GuestCount AgeQualifyingCode="Child"  Age="' + childItem + '" Count="1" />';
                });
            }
            roomStayCandidates += '</GuestCounts></RoomStayCandidate>';
        });
        let xmlData = '<OTA_HotelAvailRQ>';
        xmlData += '<AvailRequestSegments>';
        xmlData += '<AvailRequestSegment>';
        xmlData += '<HotelSearchCriteria>';
        xmlData += '<Criterion>';
        if (action === 'next') {
            valueJson[0].dates.dates[0] = moment(valueJson[0].dates.dates[0], "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalali[0] = moment(valueJson[0].dates.datesJalali[0], "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalaliFormatted[0] = moment(valueJson[0].dates.datesJalaliFormatted[0], "YYYY-MM-DD").add(1, 'days').format("YYYY/MM/DD");
            valueJson[0].dates.dates[1] = moment(valueJson[0].dates.dates[1], "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalali[1] = moment(valueJson[0].dates.datesJalali[1], "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalaliFormatted[1] = moment(valueJson[0].dates.datesJalaliFormatted[1], "YYYY-MM-DD").add(1, 'days').format("YYYY/MM/DD");
        } else if (action === 'prev') {
            valueJson[0].dates.dates[0] = moment(valueJson[0].dates.dates[0], "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalali[0] = moment(valueJson[0].dates.datesJalali[0], "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalaliFormatted[0] = moment(valueJson[0].dates.datesJalaliFormatted[0], "YYYY-MM-DD").subtract(1, 'days').format("YYYY/MM/DD");
            valueJson[0].dates.dates[1] = moment(valueJson[0].dates.dates[1], "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalali[1] = moment(valueJson[0].dates.datesJalali[1], "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
            valueJson[0].dates.datesJalaliFormatted[1] = moment(valueJson[0].dates.datesJalaliFormatted[1], "YYYY-MM-DD").subtract(1, 'days').format("YYYY/MM/DD");
        }
        xmlData += '<StayDateRange Start="' + valueJson[0].dates.dates[0] + '" End="' + valueJson[0].dates.dates[1] + '" />';
        xmlData += '<Address>';
        xmlData += '<CityName>' + (valueJson[0].city.city_en !== undefined ? valueJson[0].city.city_en : valueJson[0].city.city_name) + '</CityName>';
        xmlData += '<CountryName Code="' + valueJson[0].city.country_code + '"></CountryName>';
        xmlData += '</Address>';
        xmlData += '<RateRange MinRate="1" MaxRate="5" />';
        xmlData += '<Profiles>';
        xmlData += '<ProfileInfo>';
        xmlData += '<Profile>';
        xmlData += '<Customer CurrencyCode="IRR">';
        xmlData += '<CitizenCountryName Code="IR"/>';
        xmlData += '</Customer>';
        xmlData += '</Profile>';
        xmlData += '</ProfileInfo>';
        xmlData += '</Profiles>';
        xmlData += '<RoomStayCandidates>' + roomStayCandidates + '</RoomStayCandidates>';
        xmlData += '</Criterion>';
        xmlData += '</HotelSearchCriteria>';
        xmlData += '</AvailRequestSegment>';
        xmlData += '</AvailRequestSegments>';
        xmlData += '</OTA_HotelAvailRQ>';
        try {
            const results = await axios.post(hotelsSearch, xmlData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (results.data.items.hotelStays.hotelStay.length) {
                let resultItems = [] as any;
                resultItems.hotelStays = {} as any;
                resultItems.hotelStays.hotelStay = [] as any;
                resultItems.roomStays = results.data.items.roomStays;
                setRoomStays(results.data.items.roomStays);
                resultItems.success = results.data.items.success;
                resultItems.targetName = results.data.items.targetName;
                results.data.items.hotelStays.hotelStay.forEach((hotelStayItem: any) => {
                    hotelStayItem.hotelName = hotelStayItem.basicPropertyInfo.hotelName;
                    hotelStayItem.finalPrice = [parseInt(hotelStayItem.price[0].amountAfterTax)];
                    hotelStayItem.hotelRating = hotelStayItem.basicPropertyInfo.award[0].rating;
                    hotelStayItem.hotelImage = hotelImagePlaceholder;
                    hotelStayItem.roomNames = [];
                    hotelStayItem.basicPropertyInfo.vendorMessages.vendorMessage.forEach((item: any) => {
                        if (item.infoType === 'PersianHotelName') {
                            hotelStayItem.hotelName = item.title;
                        }
                        if (item.infoType === 'FinalAmount') {
                            hotelStayItem.finalPrice = parseInt(item.title);
                        }
                        if (item.infoType === 'Picture') {
                            hotelStayItem.hotelImage = item.title;
                        }
                        if (item.infoType === 'PersianRoomType') {
                            hotelStayItem.roomNames.push(item);
                        }
                    })
                    resultItems.hotelStays.hotelStay.push(hotelStayItem);
                })
                originalData.current = resultItems;
                handleData(resultItems);
                expireInterval.current = setInterval(() => {
                    if (expireTime.current === 0) {
                        ShowSwal(swalOptions);
                    }
                    expireTime.current = expireTime.current - 1000;
                }, 1000);
            } else {
                setState({ ...state, hotelData: [], errorMessage: 'نتیجه ای یافت نشد!' });
                setLoading(false);
            }
            setHotelJson(valueJson);
        } catch (error) {
            console.log(error);
            setState({ ...state, hotelData: [], errorMessage: 'نتیجه ای یافت نشد!' });
            setLoading(false);
        }
    }
    useIonViewWillEnter(() => {
        setLoading(true);
        fetchHotelSearch();
    })
    const lastItem = state.activePage * perPage;
    const firstItem = lastItem - perPage;
    const handleCodeCallback = (childData: any) => {
        let hotelCodeKeyword = '' as string;
        if (childData) {
            hotelCodeKeyword = childData;
        };
        setState({
            ...state,
            filters: {
                ...state.filters,
                hotelCode: hotelCodeKeyword
            }
        });
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    const hotelCard = state.hotelData.slice(firstItem, lastItem).map((item: any, index) =>
        <HotelCard key={index + '' + state.activePage} id={index} data={item} hotelDefines={state.hotelDefines} roomStays={roomStays} codeParentCallback={handleCodeCallback} expireTime={expireTime} />
    )
    const setPage = (event: any, page: any) => {
        setState({ ...state, activePage: page });
        setTimeout(() => {
            myRefCurrent.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }
    const setHotelJson = async (hotelJson: any) => {
        await Storage.set({
            key: 'hotelJson',
            value: JSON.stringify(hotelJson),
        });
    };
    const changeDay = async (action: string) => {
        clearInterval(expireInterval.current);
        setLoading(true);
        fetchHotelSearch(action);
    }
    const handleHotelSortCallback = (childData: any) => {
        setState({ ...state, sortBy: childData });
    }
    useEffect(() => {
        handleData(searchData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.filters, state.sortBy]);
    const handleHotelFilterCallback = (childData: any) => {
        let hotelPriceArray = [] as any;
        let hotelRateArray = [] as any;
        let hotelSearchKeyword = '' as string;
        Object.entries(childData.hotelPrice).filter(([k, v]: any) => k === 'lower' || k === 'upper').forEach((item) => {
            hotelPriceArray.push(item[1]);
        });
        Object.entries(childData.hotelRate).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            hotelRateArray.push(item[1]);
        });
        if (childData.searchKeyword) {
            hotelSearchKeyword = childData.searchKeyword;
        };
        setState({
            ...state,
            filters: {
                hotelPrice: { lower: hotelPriceArray[0], upper: hotelPriceArray[1] },
                hotelRate: hotelRateArray,
                searchKeyword: hotelSearchKeyword,
                hotelCode: null
            }
        });
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    const removeFilter = () => {
        setState({ ...state, filters: { hotelPrice: { lower: 0, upper: 0 }, hotelRate: [], searchKeyword: '', hotelCode: null } });
        showRemoveFilter.current = false;
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    function doRefresh() {
        window.location.reload();
    }
    return (
        <IonPage className="hotel-search-page page-padding-top">
            <IonContent fullscreen>
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <div className="ion-padding" ref={myRef}>
                    {state.errorMessage.trim() !== '' ?
                        <>
                            <div className="box-error">
                                <IonImg src={warningSign} />
                                <p>{state.errorMessage}</p>
                            </div>
                            <IonButton className="ion-margin-top" color="warning" expand="block" onClick={() => history.replace('/home')}>
                                تغییر جستجو
                                <IonIcon icon={search} className="ion-margin-start" />
                            </IonButton>
                        </>
                        : Object.keys(state.hotelDefines.all).length !== 0 && !loading &&
                        <>
                            <React.Fragment>
                                <div className="hotel-search-info">
                                    <span>{state.hotelDefines.all[0].rooms[0].adults + state.hotelDefines.all[0].rooms[0].childs} مسافر - </span>
                                    <span>تاریخ ورود : {state.hotelDefines.all[0].dates.datesJalaliFormatted[0]} - </span>
                                    <span>تاریخ خروج : {state.hotelDefines.all[0].dates.datesJalaliFormatted[1]} - </span>
                                    <span>شهر مقصد : {state.hotelDefines.all[0].city.city_fa}</span>
                                    <IonButton color="warning" expand="block" onClick={() => history.replace('/home')}>
                                        تغییر جستجو
                                        <IonIcon icon={search} className="ion-margin-start" />
                                    </IonButton>
                                </div>
                            </React.Fragment>
                            <IonList>
                                <React.Fragment key={'ReactFragment'}>
                                    {state.totalPages > 0 &&
                                        <React.Fragment>
                                            {hotelCard}
                                            <div className="my-pagination">
                                                <span>صفحه {state.activePage} از {state.totalPages}</span>
                                                {state.totalPages > 1 &&
                                                    <Pagination
                                                        pages={state.totalPages}
                                                        activePage={state.activePage}
                                                        onChange={setPage}
                                                    />
                                                }
                                            </div>
                                            <div className="total-records">
                                                تعداد هتل های یافت شده {state.hotelData.length}
                                            </div>
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            </IonList>
                        </>
                    }
                    {showRemoveFilter.current &&
                        <IonButton color="danger" expand="block" onClick={() => { removeFilter() }} className="remove-filters-btn">
                            حذف فیلترها
                        </IonButton>
                    }
                </div>
                {loading &&
                    <Splash showText={true} />
                }
            </IonContent>
            {Object.keys(state.hotelDefines.all).length !== 0 && !loading &&
                <div className="hotel-search-filter-btns">
                    <HotelSort hotelSortParentCallback={handleHotelSortCallback} disabled={state.hotelData.length ? false : true} />
                    <HotelFilter
                        data={state.hotelData}
                        dataAlt={originalData.current}
                        hotelFilterParentCallback={handleHotelFilterCallback}
                        filters={state.filters}
                        disabled={state.hotelData.length ? false : true}
                        codeParentCallback={handleCodeCallback}
                    />
                    <span onClick={() => changeDay('prev')} className={state.hotelDefines.all[0].dates.dates[0] === moment.utc().format('YYYY-MM-DD') ? 'disabled' : ''}>
                        <IonIcon icon={prevImg} />
                        روز قبل
                    </span>
                    <span onClick={() => changeDay('next')}>
                        روز بعد
                        <IonIcon icon={nextImg} />
                    </span>
                </div>
            }
        </IonPage >
    );
};

export default HotelSearch;